module.exports = __webpack_public_path__ + "img/laptop-offline.8ee145b6.png";